/*
  Product gallery, full screen viewer.
  - phones (swipe row, see joyvo-product-viewer.css): when the viewer opens, the row scrolls to the photo that was tapped
    (the theme tries to do this itself but its way only works for a stacked column); the arrow keys move one photo
  - tablets and desktop (one photo at a time): the round arrows and the arrow keys show the previous or next photo.
    This only changes which photo is marked "active" in the theme's own viewer (<product-modal>), so opening on the
    clicked photo, closing and focus handling stay as the theme does them.
  Touch screens and trackpads swipe on their own on phones (native scrolling with snapping).
*/
(function () {
  const desktop = window.matchMedia('(min-width: 750px)');

  function setup(modal) {
    if (modal.dataset.joyvoViewer) return;
    modal.dataset.joyvoViewer = 'true';
    const content = modal.querySelector('.product-media-modal__content');
    const prev = modal.querySelector('.joyvo-viewer-arrow--prev');
    const next = modal.querySelector('.joyvo-viewer-arrow--next');
    if (!content) return;

    // the gallery shows every normal photo, plus the selected variant's photo first; other variant photos stay hidden
    const photos = () =>
      [...content.querySelectorAll(':scope > [data-media-id]')].filter(
        (photo, index) => index === 0 || !photo.classList.contains('product__media-item--variant')
      );
    const current = () => Math.max(0, photos().findIndex((photo) => photo.classList.contains('active')));

    // ---- tablets and desktop: one photo at a time
    const updateArrows = () => {
      if (!prev || !next) return;
      const total = photos().length;
      prev.disabled = current() <= 0;
      next.disabled = current() >= total - 1;
      prev.hidden = next.hidden = total < 2;
    };

    const show = (index) => {
      const list = photos();
      if (index < 0 || index >= list.length) return;
      content.querySelectorAll(':scope > [data-media-id]').forEach((photo) => photo.classList.remove('active'));
      list[index].classList.add('active');
      if (window.pauseAllMedia) window.pauseAllMedia();
      updateArrows();
    };

    [[prev, -1], [next, 1]].forEach(([button, direction]) => {
      if (!button) return;
      button.addEventListener('click', (event) => { event.stopPropagation(); show(current() + direction); });
      // the theme closes the viewer on a mouse click outside the photo: a click on an arrow must not
      button.addEventListener('pointerup', (event) => event.stopPropagation());
    });

    // ---- phones: scroll the row to the tapped photo
    const goToTapped = () => {
      const active = content.querySelector(':scope > .active');
      if (!active || desktop.matches) return;
      const padding = parseFloat(getComputedStyle(content).paddingLeft) || 0;
      const left = active.getBoundingClientRect().left - content.getBoundingClientRect().left + content.scrollLeft - padding;
      // jump straight to it (the row has smooth scrolling, which would make it slide in from the first photo)
      content.style.scrollBehavior = 'auto';
      content.scrollTo({ left });
      content.style.scrollBehavior = '';
    };

    // the theme marks the tapped photo and scrolls the container as it opens: run after that
    new MutationObserver(() => {
      if (!modal.hasAttribute('open')) return;
      updateArrows();
      requestAnimationFrame(goToTapped);
      setTimeout(goToTapped, 120);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    document.addEventListener('keydown', (event) => {
      if (!modal.hasAttribute('open')) return;
      const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
      if (!direction) return;
      if (desktop.matches) show(current() + direction);
      else {
        const list = photos();
        if (list.length) content.scrollBy({ left: direction * (list[0].getBoundingClientRect().width + 10), behavior: 'smooth' });
      }
    });
  }

  const init = () => document.querySelectorAll('product-modal').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
